export default __webpack_public_path__ + "static/media/SofiaPro-Regular.f02df937.otf";